import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const ROWS = [
  { name: "Essential", purpose: "Maintain your session, currency preference, and admin auth.", optOut: "Cannot be disabled — required for the site to function." },
  { name: "Analytics (PostHog)", purpose: "Anonymised page views, clicks, and session recordings (no keystrokes).", optOut: "Block via your browser's Do Not Track or extensions like uBlock." },
  { name: "Affiliate attribution", purpose: "When you click \"Buy here\", a referral parameter may be appended to the destination URL.", optOut: "Open the registrar's homepage directly in a new tab." },
];

export default function Cookies() {
  return (
    <Layout>
      <Seo
        title="Cookie Policy"
        description="How and why Dompryce uses cookies and similar technologies."
        path="/cookies"
      />
      <article className="mx-auto max-w-3xl py-8" data-testid="cookies-page">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">Legal</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-zinc-900 md:text-5xl">
          Cookie Policy
        </h1>
        <p className="mt-3 text-sm text-zinc-500">Last updated: February 2026</p>

        <div className="mt-10 space-y-6 text-base leading-relaxed text-zinc-700">
          <p>
            Dompryce uses a minimal set of cookies and browser-storage values to keep the site fast and useful. We do not use
            cross-site advertising cookies.
          </p>

          <div className="overflow-x-auto rounded-2xl border border-zinc-100">
            <table className="min-w-full text-sm">
              <thead className="bg-zinc-50 text-left text-xs uppercase tracking-wider text-zinc-500">
                <tr>
                  <th className="px-4 py-3">Category</th>
                  <th className="px-4 py-3">Purpose</th>
                  <th className="px-4 py-3">Opt-out</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-100">
                {ROWS.map((r) => (
                  <tr key={r.name}>
                    <td className="px-4 py-3 font-medium text-zinc-900">{r.name}</td>
                    <td className="px-4 py-3 text-zinc-600">{r.purpose}</td>
                    <td className="px-4 py-3 text-zinc-600">{r.optOut}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2 className="mt-8 font-display text-xl font-semibold text-zinc-900">Local storage</h2>
          <p>
            We use your browser's <code>localStorage</code> to remember your currency preference and (for admins) your auth
            token. These never leave your device unless you explicitly authenticate.
          </p>

          <h2 className="mt-8 font-display text-xl font-semibold text-zinc-900">Questions?</h2>
          <p>
            Email <a href="mailto:support@dompryce.com" className="font-medium text-indigo-600 hover:text-indigo-500">support@dompryce.com</a>.
          </p>
        </div>
      </article>
    </Layout>
  );
}
